document.addEventListener('change', function (e) {
  const selectedInput = e.target.closest(
    '.product-bundle input[name="package"], .product-bundle input[name="package-new"]'
  );

  if (!selectedInput) return;

  const variantId = selectedInput.value;

  // Sync both bundle sections
  document.querySelectorAll(
    '.product-bundle input[name="package"], .product-bundle input[name="package-new"]'
  ).forEach(function (input) {
    const label = input.closest('label');

    input.checked = input.value === variantId;

    if (label) {
      label.classList.toggle('active', input.checked);
    }
  });

  // Update EVERY product form on the page
  document.querySelectorAll(
    'form[data-type="add-to-cart-form"] input.product-variant-id[name="id"]'
  ).forEach(function (input) {
    input.value = variantId;
    input.disabled = false;
  });

  console.log('Bundle variant selected:', variantId);
});
